document.addEventListener('DOMContentLoaded', function () {
  var form = document.getElementById('AteemaLeadForm');
  if (!form) return;

  var submitBtn = document.getElementById('AteemaSubmitBtn');
  var generalError = document.getElementById('AteemaGeneralError');
  var successState = document.querySelector('.ateema-form-state--success');
  var defaultState = document.querySelector('.ateema-form-state--default');
  var endpoint = form.getAttribute('data-endpoint');

  var debugStatus = document.getElementById('AteemaDebugStatus');
  var debugEndpoint = document.getElementById('AteemaDebugEndpoint');

  function setDebug(message) {
    console.log('[Ateema Debug]', message);
    if (debugStatus) debugStatus.textContent = message;
  }

  function setFieldError(name, message) {
    var errorEl = form.querySelector('[data-error-for="' + name + '"]');
    var input = form.querySelector('[name="' + name + '"]');
    if (errorEl) errorEl.textContent = message || '';
    if (input) {
      if (message) input.classList.add('ateema-input--invalid');
      else input.classList.remove('ateema-input--invalid');
    }
  }

  function validateForm() {
    var isValid = true;
    var firstName = (form.first_name.value || '').trim();
    var email = (form.email.value || '').trim();

    setFieldError('first_name', '');
    setFieldError('email', '');
    if (generalError) generalError.hidden = true;

    if (!firstName) {
      setFieldError('first_name', 'First name is required.');
      isValid = false;
    }

    if (!email) {
      setFieldError('email', 'Email is required.');
      isValid = false;
    } else {
      var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(email)) {
        setFieldError('email', 'Enter a valid email address.');
        isValid = false;
      }
    }

    return isValid;
  }

  function showSuccess() {
    if (defaultState) defaultState.hidden = true;
    if (successState) successState.hidden = false;
  }

  function showError() {
    if (generalError) generalError.hidden = false;
  }

  if (debugEndpoint) {
    debugEndpoint.textContent = endpoint || 'EMPTY';
  }

  setDebug(endpoint ? 'Endpoint loaded' : 'Endpoint missing');

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    setDebug('Submit clicked');

    if (!validateForm()) {
      setDebug('Validation failed');
      return;
    }

    if (!endpoint) {
      setDebug('Endpoint missing in data-endpoint');
      showError();
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting...';

    var formData = new FormData(form);

    setDebug('Sending fetch request');

    fetch(endpoint, {
      method: 'POST',
      body: formData,
      mode: 'cors'
    })
      .then(function (response) {
        setDebug('Fetch completed. Status: ' + response.status);
        return response.text();
      })
      .then(function (text) {
        console.log('[Ateema Debug] Raw response:', text);
        setDebug('Response received');
        showSuccess();
        form.reset();
        submitBtn.disabled = false;
        submitBtn.textContent = 'Submit';
      })
      .catch(function (error) {
        console.error('[Ateema Debug] Fetch error:', error);
        setDebug('Fetch failed: ' + error.message);
        showError();
        submitBtn.disabled = false;
        submitBtn.textContent = 'Submit';
      });
  });
});